import React from 'react'

const BkFlowNavigationBackButton = props =>  {
	const {
		isMobileButton,
		isDisabled,
		toggleEvent,
		buttonContent,
	} = props

	return  (
		<div
			className={ isMobileButton ?
				"bk-flow-navigation__prev btn btn-text-only mobile start-xs middle-xs col-xs-2 u-remove-padding"
			:
				"bk-flow-navigation__prev center-xs middle-xs u-remove-padding"
			}
			disabled={ isDisabled }
			tabIndex={ 0 }
			onClick={ toggleEvent }
		>
			{ process.env.REACT_APP_COMPONENT_NAVIGATION_ARROW_ICON_TYPE === 'caret' ?
				<i className="material-icons">keyboard_arrow_left</i>
			:
				<i className="material-icons">arrow_left</i>
			}
			<span className={ isMobileButton ?
				"bk-flow-navigation__prev-txt u-font-small u-font-bold"
			:
				"bk-flow-navigation__prev-txt u-font-xs u-font-bold"
			}>
				{ buttonContent }
			</span>
		</div>
	)
}

export default BkFlowNavigationBackButton


// WEBPACK FOOTER //
// ./src/components/structure/navigation/elements/BkFlowNavigationBackButton.js